// extracted by mini-css-extract-plugin
export var calculated = "styles-module--calculated--9d840";
export var highlightedText = "styles-module--highlightedText--f58eb";
export var lb = "styles-module--lb--24df1";
export var lt = "styles-module--lt--2176e";
export var rb = "styles-module--rb--67889";
export var rt = "styles-module--rt--75259";
export var tooltip = "styles-module--tooltip--1345f";
export var tooltipBody = "styles-module--tooltipBody--d5f7f";
export var tooltipHeader = "styles-module--tooltipHeader--31b76";